<script setup lang="ts">
defineProps<{
  label: string;
  icon: string;
  rootClass?: string;
  iconClass?: string;
  labelClass?: string;
  valueClass?: string;
  value: string;
}>();

function normalizeValue(value: string) {
  const invalidValues = [
    0,
    "0",
    null,
    undefined,
    "",
    "N/A",
    "n/a",
    "No",
    "no",
    "-",
    "null",
    "undefined",
  ];

  return invalidValues.includes(String(value).trim())
    ? "Not Provided Yet"
    : value;
}
</script>

<template>
  <div
    :class="[
      'col-span-1 md:col-span-4 w-full rounded-2xl flex gap-4 items-start flex-nowrap',
      rootClass,
    ]"
  >
    <i
      :class="['pi text-xl sm:text-2xl text-gray-600 mt-1', icon, iconClass]"
    ></i>

    <div class="space-y-1.5">
      <p :class="['text-xs sm:text-sm font-normal text-gray-500', labelClass]">
        {{ label }}
      </p>
      <p
        v-if="value"
        :class="['text-sm sm:text-base font-bold text-primary-500', valueClass]"
      >
        {{
          value === "EduRank Ranking 0"
            ? "Data Not Available"
            : normalizeValue(value)
        }}
      </p>
      <slot v-else></slot>
    </div>
  </div>
</template>
